<template>
  <!--*组件名称
      * @module '@/components/ebPartyInfo/ebPartyInfoEn'
      * @desc 收发通信息组件(English)
      * @author lwc
      * @date  2021年3月17日
      * @param {} []    - 参数说明
      * @param {} [] - 参数说明
      * @example 调用示例
          * @getEbPartyInfo="getEbPartyInfo"：子向父传值，父取值；
          * :cargoInfoForm="cargoInfoForm"：父向子传值，子组件中用props接收
          * //子向父传值：
          * this.$emit('getEbPartyInfo', objGroup)
          * //父取值
          * <send-receive-info
              @getEbPartyInfo = "getEbPartyInfo"
              :ebPartyInfoForm = "ebPartyInfoForm"/>
  -->
  <div>
    <el-form
      :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
      ref="ebPartyInfoFormRef" :rules="ebPartyInfoFormRules" :model="ebParty"
      class="form-panel" label-position="top">
  <!--     <el-row class="title-panel">
        <el-col>
          <span class="title-text">Shipper&Consignee&Notify</span>
        </el-col>
      </el-row> -->
         <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">Shipper&Consignee&Notify</span>
                </el-col>
                </div>
              </el-row>
      <el-row class="content-panel transceiver">
        <el-col>
          <el-tabs type="card" v-model="ebPartyDialogForm.activeName" @tab-click="handleClick">
            <el-tab-pane class="tabs-pane" label="Shipper & Consignee & Notify" name="0">
              <el-row>
                <el-col>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartySHInfoFormRef" :rules="ebPartySHInfoFormRules" :model="ebParty.ebPartySH"
                    class="form-panel" label-position="top">
                    <el-form-item prop="partyDescription">
                      <div class="top-inline">
                                        <span class="link" slot="label" @click="ebPartyDialogVisible=true">
                                           <span style="font-size: 12px"> Shipper:</span>
                                        </span>
<!--                                  <el-button-->
<!--                                    class="elbtn-save"-->
<!--                                  @click="saveShipperCneeNotifySH()"-->
<!--                                  ><svg-icon icon-class="save"></svg-icon>-->
<!--                                  保存模板-->
<!--                                </el-button>-->
                        </div>
                      <el-associate
                          style="width: 100%"
                          :columns="associate_columns_part"
                          :query-method="associate_queryMethod_party_CN"
                          class="input_length"
                          clearable
                          :disabled="editable"
                          :allow-create="true"
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="shipperCneeNotifyNameEn"
                          value-prop="shipperCneeNotifyNameEn"
                          placeholder=""
                          v-model="ebParty.ebPartyCN.partyMainName"
                          :title="ebParty.ebPartyCN.partyMainName"
                          size="mini"
                          @change="onChangePartCN"
                          case="upper"
                      />
                     </el-form-item>
                     <el-form-item>
                      <el-input
                        size="mini"
                        type="textarea"
                        :rows="6"
                        case="upper"
                        :disabled="editable"
                        @change="ebPartyInfoValue"
                        v-model="ebParty.ebPartySH.partyDescription">
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyCNInfoFormRef" :rules="ebPartyCNInfoFormRules" :model="ebParty.ebPartyCN"
                    class="form-panel" label-position="top">
                    <el-form-item prop="partyDescription">
                                 <div class="top-inline">
                                        <span class="link" slot="label" @click="ebPartyDialogVisible=true">
                                            <span style="font-size: 12px">Consignee:</span>
                                        </span>
<!--                                        <el-button-->
<!--                                          class="elbtn-save"-->
<!--                                          @click="saveShipperCneeNotifyNT()"-->
<!--                                          ><svg-icon icon-class="save"></svg-icon>-->
<!--                                          保存模板-->
<!--                                        </el-button>-->
                                 </div>
                                <el-associate
                                    style="width: 100%"
                                    :columns="associate_columns_part"
                                    :query-method="associate_queryMethod_party_CN"
                                    class="input_length"
                                    clearable
                                    :allow-create="true"
                                    :query-length="0"
                                    :default-first-option="true"
                                    label-prop="shipperCneeNotifyNameEn"
                                    value-prop="shipperCneeNotifyNameEn"
                                    placeholder=""
                                    v-model="ebParty.ebPartyCN.partyMainName"
                                    :title="ebParty.ebPartyCN.partyMainName"
                                    size="mini"
                                    @change="onChangePartCN"
                                    case="upper"
                                    :disabled="editable"
                                />
                              </el-form-item>
                              <el-form-item>
                      <el-input
                        size="mini"
                        type="textarea"
                        @change="ebPartyInfoValue"
                        :rows="6"
                        case="upper"
                        :disabled="editable"
                        v-model="ebParty.ebPartyCN.partyDescription">
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyNTInfoFormRef" :rules="ebPartyNTInfoFormRules" :model="ebParty.ebPartyNT"
                    class="form-panel" label-position="top">
                    <el-form-item prop="partyDescription">
                      <div class="top-inline">
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true" style="font-size: 12px">
                            Notify:
                        </span>
<!--                          <el-button-->
<!--                          class="elbtn-save"-->
<!--                          @click="saveShipperCneeNotifyNT()"-->
<!--                          ><svg-icon icon-class="save"></svg-icon>-->
<!--                          保存模板-->
<!--                        </el-button>-->
                        <el-radio-group v-model="radio" @change="copyCnee" class="notify">
                          <el-radio label="1">COPY CNEE</el-radio>
                          <el-radio label="2">SAME AS CONSIGNEE</el-radio>
                        </el-radio-group>
                      </div>
                      <el-associate
                          style="width: 100%"
                          :columns="associate_columns_part"
                          :query-method="associate_queryMethod_party_NT"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :allow-create="true"
                          :default-first-option="true"
                          label-prop="shipperCneeNotifyNameEn"
                          value-prop="shipperCneeNotifyNameEn"
                          placeholder=""
                          v-model="ebParty.ebPartyNT.partyMainName"
                          :title="ebParty.ebPartyNT.partyMainName"
                          size="mini"
                          @change="onChangePartNT"
                          case="upper"
                          :disabled="editable"
                      />
                    </el-form-item>
                    <el-form-item>
                      <el-input
                        size="mini"
                        type="textarea"
                        @change="ebPartyInfoValue"
                        case="upper"
                        :rows="6"
                        :disabled="editable"
                        v-model="ebParty.ebPartyNT.partyDescription">
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="Actual Shipper & Consignee & Notify" name="1">
              <el-row>
                <el-col>
                  <el-form-item>
                    <div class="top-inline">
                    <span class="link" slot="label" @click="ebPartyDialogVisible=true" style="font-size: 12px">
                        Actual Shipper:
                    </span>
<!--                         <el-button-->
<!--                          class="elbtn-save"-->
<!--                          @click="saveShipperCneeNotifyRSH()"-->
<!--                          ><svg-icon icon-class="save"></svg-icon>-->
<!--                          保存模板-->
<!--                        </el-button>-->
                    </div>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_SH"
                        class="input_length"
                        clearable
                        :allow-create="true"
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyRSH.partyMainName"
                        :title="ebParty.ebPartyRSH.partyMainName"
                        size="mini"
                        @change="onChangePartRSH"
                        case="upper"
                        :disabled="editable"
                      />
                    </el-form-item>
                    <el-form-item>
                    <el-input
                      size="mini"
                      type="textarea"
                      @change="ebPartyInfoValue"
                      :rows="6"
                      case="upper"
                      :disabled="editable"
                      v-model="ebParty.ebPartyRSH.partyDescription">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item>
                    <div class="top-inline">
                    <span style="font-size: 12px" class="link" slot="label" @click="ebPartyDialogVisible=true">
                        Actual Consignee:
                    </span>
<!--                        <el-button-->
<!--                          class="elbtn-save"-->
<!--                          @click="saveShipperCneeNotifyRCN()"-->
<!--                          ><svg-icon icon-class="save"></svg-icon>-->
<!--                          保存模板-->
<!--                        </el-button>-->
                    </div>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_CN"
                        class="input_length"
                        clearable
                        :allow-create="true"
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyRCN.partyMainName"
                        :title="ebParty.ebPartyRCN.partyMainName"
                        size="mini"
                        @change="onChangePartRCN"
                        case="upper"
                        :disabled="editable"
                      />
                    </el-form-item>
                    <el-form-item>
                    <el-input
                      size="mini"
                      type="textarea"
                      @change="ebPartyInfoValue"
                      :rows="6"
                      case="upper"
                      :disabled="editable"
                      v-model="ebParty.ebPartyRCN.partyDescription">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item>
                     <div class="top-inline">
                    <span style="font-size: 12px" class="link" slot="label" @click="ebPartyDialogVisible=true">
                        Actual Notify:
                    </span>
<!--                          <el-button-->
<!--                          class="elbtn-save"-->
<!--                          @click="saveShipperCneeNotifyRNT()"-->
<!--                          ><svg-icon icon-class="save"></svg-icon>-->
<!--                          保存模板-->
<!--                        </el-button>-->
                     </div>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_NT"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :allow-create="true"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyRNT.partyMainName"
                        :title="ebParty.ebPartyRNT.partyMainName"
                        size="mini"
                        @change="onChangePartRNT"
                        case="upper"
                        :disabled="editable"
                      />
                    </el-form-item>
                    <el-form-item>
                    <el-input
                      size="mini"
                      type="textarea"
                      case="upper"
                      @change="ebPartyInfoValue"
                      :rows="6"
                      :disabled="editable"
                      v-model="ebParty.ebPartyRNT.partyDescription">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-form>
    <!-- Shipper & Consignee & Notify弹框 -->
    <el-dialog
      :visible.sync="ebPartyDialogVisible"
      width="90%"
      class="booking-panel"
      >
    <el-row class="title-panel-external">
      <div class="title-panel">
        <el-col>
        <span class="title-text">Shipper & Consignee & Notify</span>
      </el-col>
      </div>
    </el-row>
      <el-form
        :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
        ref="ebPartyDialogFormRef" :rules="ebPartyDialogFormRules" :model="ebPartyDialogForm"
        class="form-panel" label-position="top">
        <el-tabs type="card" v-model="ebPartyDialogForm.activeName">
          <el-tab-pane label="Shipper & Consignee & Notify" name="0">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="padding:0px 5px;">
              <el-col :span="6">
                <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                   <span class="title-text cargo-title-text">Shipper</span>
                  </el-row>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartySHDialogFormRef" :rules="ebPartySHDialogFormRules" :model="ebParty.ebPartySH"
                    class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="PartyMainName:" prop="partyMainName">
                        <el-input case="upper" size="mini" v-model="ebParty.ebPartySH.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="PartyAddress:" prop="partyAddress">
                        <el-input
                          size="mini"
                          type="textarea"
                          :rows="3"
                          case="upper"
                          v-model="ebParty.ebPartySH.partyAddress" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Country:" prop="countryName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          case="upper"
                                          @change="onChangeCountryEbPartySH"
                                          v-model="ebParty.ebPartySH.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Area:" prop="areaName">
                            <!-- <label slot="label" class="label_no"></label> -->
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.areaName" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="PostCode:" prop="postCode">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Email:" prop="email">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Contact:" prop="contactPerson">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.contactPerson">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Mobile Phone:" prop="mobilePhone">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.mobilePhone">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="TaxNo:" prop="taxNo">
                        <el-input
                          size="mini"
                          case="upper"
                          v-model="ebParty.ebPartySH.taxNo">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AeoNo:" prop="aeoNo">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.aeoNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Company Code:" prop="carrierCode">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartySH.carrierCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                   <span class="title-text cargo-title-text">Consignee</span>
                  </el-row>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyCNDialogFormRef" :rules="ebPartyCNDialogFormRules" :model="ebParty.ebPartyCN"
                    class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="PartyMainName:" prop="partyMainName">
                        <el-input size="mini" case="upper" v-model="ebParty.ebPartyCN.partyMainName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="PartyAddress:" prop="partyAddress">
                        <el-input
                          size="mini"
                          case="upper"
                          type="textarea"
                          :rows="3"
                          v-model="ebParty.ebPartyCN.partyAddress">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Country:" prop="countryName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyCN"
                                          v-model="ebParty.ebPartyCN.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Area:" prop="areaName">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.areaName">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="PostCode:" prop="postCode">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.postCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Email:" prop="email">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.email">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Contact:" prop="contactPerson">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.contactPerson">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Mobile Phone:" prop="mobilePhone">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.mobilePhone">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="TaxNo:" prop="taxNo">
                        <el-input
                          size="mini"
                          case="upper"
                          v-model="ebParty.ebPartyCN.taxNo">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AeoNo:" prop="aeoNo">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.aeoNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Company Code:" prop="carrierCode">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyCN.carrierCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
                   <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                   <span class="title-text cargo-title-text">Notify</span>
                  </el-row>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyNTDialogFormRef" :rules="ebPartyNTDialogFormRules" :model="ebParty.ebPartyNT"
                    class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="PartyMainName:" prop="partyMainName">
                        <el-input size="mini" case="upper" v-model="ebParty.ebPartyNT.partyMainName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="PartyAddress:" prop="partyAddress">
                        <el-input
                          size="mini"
                          type="textarea"
                          :rows="3"
                          case="upper"
                          v-model="ebParty.ebPartyNT.partyAddress">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Country:" prop="countryName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyNT"
                                          v-model="ebParty.ebPartyNT.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Area:" prop="areaName">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.areaName">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="PostCode:" prop="postCode">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.postCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Email:" prop="email">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.email">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Contact:" prop="contactPerson">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.contactPerson">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Mobile Phone:" prop="mobilePhone">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.mobilePhone">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="TaxNo:" prop="taxNo">
                        <el-input
                          size="mini"
                          case="upper"
                          v-model="ebParty.ebPartyNT.taxNo">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AeoNo:" prop="aeoNo">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.aeoNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Company Code:" prop="carrierCode">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT.carrierCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6" class="notify-unit">
                 <el-row class="cargo-type second-notifier">
                <el-tabs type="card" class="el-tab_tran" v-model="ebPartyDialogForm.activeChildName" @tab-click="handleClick">
                  <el-tab-pane class="el-tab_tran" label="SecondNotify" name="0">
                    <el-form
                      :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyNT2DialogFormRef" :rules="ebPartyNT2DialogFormRules"
                      :model="ebParty.ebPartyNT2"
                      class="form-panel" label-position="top">
                      <el-row>
                        <el-col>
                          <el-form-item label="PartyMainName:" prop="partyMainName">
                            <el-input size="mini" case="upper" v-model="ebParty.ebPartyNT2.partyMainName"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-form-item label="PartyAddress:" prop="partyAddress">
                            <el-input
                              size="mini"
                              type="textarea"
                              :rows="3"
                              case="upper"
                              v-model="ebParty.ebPartyNT2.partyAddress">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="Country:" prop="countryName">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_country"
                                              :query-method="associate_queryMethod_country"
                                              class="input_length"
                                              clearable
                                              case="upper"
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="countryNameCn"
                                              value-prop="countryNameCn"
                                              placeholder=""
                                              @change="onChangeCountryEbPartyNT2"
                                              v-model="ebParty.ebPartyNT2.countryName"
                                              size="mini"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="Area:" prop="areaName">

                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.areaName">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="PostCode:" prop="postCode">
                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.postCode">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="Email:" prop="email">

                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.email">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="Contact:" prop="contactPerson">
                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.contactPerson">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="Mobile Phone:" prop="mobilePhone">

                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.mobilePhone">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-form-item label="TaxNo:" prop="taxNo">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyNT2.taxNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="AeoNo:" prop="aeoNo">
                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.aeoNo">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="Company Code:" prop="carrierCode">

                                <el-input
                                  size="mini"
                                  case="upper"
                                  v-model="ebParty.ebPartyNT2.carrierCode">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-form>
                  </el-tab-pane>
                  <el-tab-pane label="DGPackingUnit" name="1">
                    <el-row>
                      <el-col>
                        <el-form-item label="PartyMainName:">
                          <el-input size="mini" case="upper" v-model="ebParty.ebPartyNT.partyMainName"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-form-item label="PartyAddress:">
                          <el-input
                            size="mini"
                            type="textarea"
                            :rows="3"
                            case="upper"
                            v-model="ebParty.ebPartyNT.partyAddress">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="Country:">
                              <el-associate style="width: 100%;"
                                            :columns="associate_columns_country"
                                            :query-method="associate_queryMethod_country"
                                            class="input_length"
                                            clearable
                                            :query-length="0"
                                            case="upper"
                                            :default-first-option="true"
                                            label-prop="countryNameCn"
                                            value-prop="countryNameCn"
                                            placeholder=""
                                            @change="onChangeCountryEbPartyNT"
                                            v-model="ebParty.ebPartyNT.countryName"
                                            size="mini"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="Area:">

                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.areaName">
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="PostCode:">
                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.postCode">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="Email:">

                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.email">
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="Contact:">
                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.contactPerson">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="Mobile Phone:">

                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.mobilePhone">
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col>
                        <el-form-item label="TaxNo:">
                          <el-input
                            size="mini"
                            case="upper"
                            v-model="ebParty.ebPartyNT.taxNo">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="AeoNo:">
                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.aeoNo">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="Company Code:">

                              <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartyNT.carrierCode">
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
                  </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="Actual Shipper & Consignee & Notify" name="1">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="padding: 10px 5px;">
              <el-col :span="6">
                <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                   <span class="title-text cargo-title-text">Actual Shipper</span>
                  </el-row>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyRSHDialogFormRef" :rules="ebPartyRSHDialogFormRules" :model="ebParty.ebPartyRSH"
                    class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="PartyMainName:">
                        <el-input size="mini" case="upper" v-model="ebParty.ebPartyRSH.partyMainName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="PartyAddress:">
                        <el-input
                          size="mini"
                          case="upper"
                          type="textarea"
                          :rows="3"
                          v-model="ebParty.ebPartyRSH.partyAddress">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Country:">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyRSH"
                                          v-model="ebParty.ebPartyRSH.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Area:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.areaName">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="PostCode:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.postCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Email:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.email">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Contact:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.contactPerson">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Mobile Phone:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.mobilePhone">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="TaxNo:">
                        <el-input
                          size="mini"
                          case="upper"
                          v-model="ebParty.ebPartyRSH.taxNo">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AeoNo:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.aeoNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Company Code:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRSH.carrierCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
              <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                   <span class="title-text cargo-title-text">Actual Consignee</span>
                  </el-row>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyRCNDialogFormRef" :rules="ebPartyRCNDialogFormRules" :model="ebParty.ebPartyRCN"
                    class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="PartyMainName:">
                        <el-input size="mini" case="upper" v-model="ebParty.ebPartyRCN.partyMainName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="PartyAddress:">
                        <el-input
                          size="mini"
                          type="textarea"
                          :rows="3"
                          case="upper"
                          v-model="ebParty.ebPartyRCN.partyAddress">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Country:">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyRCN"
                                          v-model="ebParty.ebPartyRCN.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Area:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.areaName">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="PostCode:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.postCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Email:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.email">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Contact:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.contactPerson">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Mobile Phone:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.mobilePhone">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="TaxNo:">
                        <el-input
                          size="mini"
                          case="upper"
                          v-model="ebParty.ebPartyRCN.taxNo">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AeoNo:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.aeoNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Company Code:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRCN.carrierCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
                 <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                   <span class="title-text cargo-title-text">Actual Notify</span>
                  </el-row>
                  <el-form
                    :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyRNTDialogFormRef" :rules="ebPartyRNTDialogFormRules" :model="ebParty.ebPartyRNT"
                    class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="PartyMainName:">
                        <el-input size="mini" case="upper" v-model="ebParty.ebPartyRNT.partyMainName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="PartyAddress:">
                        <el-input
                          size="mini"
                          type="textarea"
                          :rows="3"
                          case="upper"
                          v-model="ebParty.ebPartyRNT.partyAddress">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Country:">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyRNT"
                                          v-model="ebParty.ebPartyRNT.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Area:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.areaName">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="PostCode:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.postCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Email:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.email">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Contact:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.contactPerson">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Mobile Phone:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.mobilePhone">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="TaxNo:">
                        <el-input
                          size="mini"
                          case="upper"
                          v-model="ebParty.ebPartyRNT.taxNo">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AeoNo:">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.aeoNo">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Company Code:">

                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebParty.ebPartyRNT.carrierCode">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" @click="ebPartyDialogClick">Save</el-button>
          <el-button type="primary" size="mini" @click="ebPartyDialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryCountryInfo, queryMdShipperCneeNotify, queryShipperCneeNotifyShipperInfo } from "@/api/commonService";
import { ebPartySHDialogFormRules, ebPartySHInfoFormRules } from "@/rules/booking_rules";

export default {
  name: 'ebPartyInfoEn',
  // 接收父组件的值
  props: {
    ebParty: {
      //Shipper
      ebPartySH: {},
      //收获人
      ebPartyCN: {},
      //Notify
      ebPartyNT: {},
      //Actual Shipper
      ebPartyRSH: {},
      //真实收获人
      ebPartyRCN: {},
      //Actual Notify
      ebPartyRNT: {},
    },
    ebOrder: {},
    editable: false
  },
  data() {
    return {
      radio: '0',
      ebPartyInfoFormRules: {},
      //校验
      ebPartySHInfoFormRules: {
        ...ebPartySHInfoFormRules
      },
      ebPartyCNInfoFormRules: {
        ...ebPartySHInfoFormRules
      },
      ebPartyNTInfoFormRules: {
        ...ebPartySHInfoFormRules
      },
      ebPartySHDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyCNDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyNTDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyNT2DialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyRSHDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyRCNDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyRNTDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
            //收发通联想控件
      associate_columns_part: [
        {
          title: "英文名称",
          field: "shipperCneeNotifyNameEn",
        },
        {
          title: "中文名称",
          field: "shipperCneeNotifyNameCn",
        }
      ],
      //国家地区联想控件
      associate_columns_country: [
        {
          title: "国家代码",
          field: 'countryCode'
        },
        {
          title: "中文名称",
          field: 'countryNameCn'
        },
        {
          title: "英文名称",
          field: 'countryNameEn'
        }
      ],
      ebPartyDialogForm: {
        active: '0',
        activeName: '0',
        activeChildName: '0'
      },
      ebPartyDialogFormRules: {},
      ebPartyDialogVisible: false,
    };
  },
  computed: {
    computedEbPartySH() {
      return JSON.stringify(this.ebParty.ebPartySH);
    },
    computedEbPartyCN() {
      return JSON.stringify(this.ebParty.ebPartyCN);
    },
    computedEbPartyNT() {
      return JSON.stringify(this.ebParty.ebPartyNT);
    },
    computedEbPartyNT2() {
      return JSON.stringify(this.ebParty.ebPartyNT2);
    },
    computedEbPartyRSH() {
      return JSON.stringify(this.ebParty.ebPartyRSH);
    },
    computedEbPartyRCN() {
      return JSON.stringify(this.ebParty.ebPartyRCN);
    },
    computedEbPartyRNT() {
      return JSON.stringify(this.ebParty.ebPartyRNT);
    },
    computedEbOrder() {
      return JSON.stringify(this.ebOrder);
    },
  },
  watch: {
    computedEbPartySH: {
      handler(newValue, oldValue) {
        let newEbPartySH = JSON.parse(newValue);
        if (newEbPartySH.rowStatus === 2) {
          this.ebParty.ebPartySH.rowStatus = 16;
        }
      },
    },
    computedEbPartyCN: {
      handler(newValue, oldValue) {
        let newEbPartyCN = JSON.parse(newValue);
        if (newEbPartyCN.rowStatus === 2) {
          this.ebParty.ebPartyCN.rowStatus = 16;
        }
      },
    },
    computedEbPartyNT: {
      handler(newValue, oldValue) {
        let newEbPartyNT = JSON.parse(newValue);
        if (newEbPartyNT.rowStatus === 2) {
          this.ebParty.ebPartyNT.rowStatus = 16;
        }
      },
    },
    computedEbPartyNT2: {
      handler(newValue, oldValue) {
        let newEbPartyNT2 = JSON.parse(newValue);
        if (newEbPartyNT2.rowStatus === 2) {
          this.ebParty.ebPartyNT2.rowStatus = 16;
        }
      },
    },
    computedEbPartyRSH: {
      handler(newValue, oldValue) {
        let newEbPartyRSH = JSON.parse(newValue);
        if (newEbPartyRSH.rowStatus === 2) {
          this.ebParty.ebPartyRSH.rowStatus = 16;
        }
      },
    },
    computedEbPartyRCN: {
      handler(newValue, oldValue) {
        let newEbPartyRCN = JSON.parse(newValue);
        if (newEbPartyRCN.rowStatus === 2) {
          this.ebParty.ebPartyRCN.rowStatus = 16;
        }
      },
    },
    computedEbPartyRNT: {
      handler(newValue, oldValue) {
        let newEbPartyRNT = JSON.parse(newValue);
        if (newEbPartyRNT.rowStatus === 2) {
          this.ebParty.ebPartyRNT.rowStatus = 16;
        }
      },
    },
    computedEbOrder: {
      handler(newValue, oldValue) {
        let newEbOrder = JSON.parse(newValue);
        // this.ebOrder = newEbOrder
        this.$emit('update:ebOrder', newEbOrder)
        this.$forceUpdate()
      },
    }
  },
  async created() {

  },
  mounted() {
    console.log("ebPartyInfo", this.ebParty)
    // let _this = this;
    // let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // Object.keys(this.ebParty).forEach(el => {
    //   _this.ebParty[el].ebUserId = userInfo.userId;
    //   _this.ebParty[el].ebUserName =  userInfo.username
    // })
  },
  methods: {
    inputForceUpdate() {
      this.$forceUpdate();
    },
        // 收发通发货人联想控件数据源
    associate_queryMethod_party_SH({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isShipper: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 收发通收货人联想控件数据源
    associate_queryMethod_party_CN({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isConsignee: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 收发通通知人联想控件数据源
    associate_queryMethod_party_NT({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isNotify: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 国家地区联想控件数据源
    associate_queryMethod_country({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          isDeleted3: "0",
          isActive4: "1"
        }
      } else {
        params = {
          countryCode0: "%" + keyword + "%",
          countryNameCn1: "%" + keyword + "%",
          countryNameEn2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1"
        }
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdCountry.countryCode"],
        mainModelName: "CTS_ILPMdCountry",
        tag: "CTS_ILP_es",
        where: "((((CTS_ILPMdCountry.countryCode LIKE :countryCode0 OR CTS_ILPMdCountry.countryNameCn LIKE :countryNameCn1) OR CTS_ILPMdCountry.countryNameEn LIKE :countryNameEn2) AND CTS_ILPMdCountry.isDeleted = :isDeleted3) AND CTS_ILPMdCountry.isActive = :isActive4)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: ["CTS_ILPMdCountry.mdCountryId", "CTS_ILPMdCountry.isDeleted", "CTS_ILPMdCountry.lastModifyTime", "CTS_ILPMdCountry.lastModifierName", "CTS_ILPMdCountry.countryNameCn", "CTS_ILPMdCountry.appCode", "CTS_ILPMdCountry.continentsCode", "CTS_ILPMdCountry.createOfficeName", "CTS_ILPMdCountry.createOffice", "CTS_ILPMdCountry.creatorId", "CTS_ILPMdCountry.countryCode", "CTS_ILPMdCountry.countryNameEn", "CTS_ILPMdCountry.isActive", "CTS_ILPMdCountry.lastModifyOffice", "CTS_ILPMdCountry.createTime", "CTS_ILPMdCountry.principalGroupCode", "CTS_ILPMdCountry.recordVersion", "CTS_ILPMdCountry.lastModifyOfficeName", "CTS_ILPMdCountry.creatorName", "CTS_ILPMdCountry.lastModifierId"],
        enableCascade: true
      }

      return new Promise(resolve => {
        queryCountryInfo(data).then(res => {
          console.log("queryCountryInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
     //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyRSH() {
      let self = this;
      self.$refs.ebPartyRSHInfoFormRef.validate(validRSH => {
        if (validRSH) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyRSH.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyRSH.partyMainName,
            isNotify: 0,
            isConsignee: 0,
            isShipper: 1
          }
          self.saveEbPartys(saveData, "发货人");
        } else {
          self.$coreMethods.message("warning", "发货人的制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyRCN() {
      let self = this;
      self.$refs.ebPartyRCNInfoFormRef.validate(validRCN => {
        if (validRCN) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyRCN.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyRCN.partyMainName,
            isNotify: 0,
            isConsignee: 1,
            isShipper: 0
          }
          self.saveEbPartys(saveData, "收货人");
        } else {
          self.$coreMethods.message("warning", "收货人的制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyRNT() {
      let self = this;
      self.$refs.ebPartyRNTInfoFormRef.validate(validRNT => {
        if (validRNT) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyRNT.partyDescription,
            shipperCneeNotifyNameEn: self.ebPartyRNT.ebPartyCN.partyMainName,
            isNotify: 1,
            isConsignee: 0,
            isShipper: 0
          }
          self.saveEbPartys(saveData, "通知人");
        } else {
          self.$coreMethods.message("warning", "通知人的制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifySH() {
      let self = this;
      self.$refs.ebPartySHInfoFormRef.validate(validSH => {
        if (validSH) {
          let saveData = {
            scnDescription: self.ebParty.ebPartySH.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartySH.partyMainName,
            isNotify: 0,
            isConsignee: 0,
            isShipper: 1
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "发货人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "发货人");
        } else {
          self.$coreMethods.message("warning", "发货人名称和制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyCN() {
      let self = this;
      self.$refs.ebPartyCNInfoFormRef.validate(validCN => {
        if (validCN) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyCN.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyCN.partyMainName,
            isNotify: 0,
            isConsignee: 1,
            isShipper: 0
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "收货人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "收货人");
        } else {
          self.$coreMethods.message("warning", "收货人名称和制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyNT() {
      let self = this;
      self.$refs.ebPartyNTInfoFormRef.validate(validNT => {
        if (validNT) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyNT.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyNT.partyMainName,
            isNotify: 1,
            isConsignee: 0,
            isShipper: 0
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "通知人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "通知人");
        } else {
          self.$coreMethods.message("warning", "通知人名称和制单信息不能为空");
        }
      })
    },
    //真实收发通发货人联想控件改变事件
    onChangePartRSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyRSH.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartySH.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyRSHInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();

    },
    //真实收发通发货人联想控件改变事件
    onChangePartRCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyRCN.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyRCN.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyRCNInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartRNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyRNT.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyRNT.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyRCNInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartySH.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartySH.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartySHInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyCN.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyCN.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyCNInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyNT.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyNT.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyNTInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    // 国家/地区
    onChangeCountryEbPartySH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartySH.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyCN.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyNT.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyNT2(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyNT2.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyRSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRSH.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyRCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRCN.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyRNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRNT.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyDG(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyDG.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    // 国家地区联想控件数据源
    associate_queryMethod_country( { keyword, pageSize, currentPage } ) {
      let params = {}
      if (keyword === '') {
        params = {
          isDeleted3: "0",
          isActive4: "1"
        }
      } else {
        params = {
          countryCode0: "%" + keyword + "%",
          countryNameCn1: "%" + keyword + "%",
          countryNameEn2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1"
        }
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdCountry.countryCode"],
        mainModelName: "CTS_ILPMdCountry",
        tag: "CTS_ILP_es",
        where: "((((CTS_ILPMdCountry.countryCode LIKE :countryCode0 OR CTS_ILPMdCountry.countryNameCn LIKE :countryNameCn1) OR CTS_ILPMdCountry.countryNameEn LIKE :countryNameEn2) AND CTS_ILPMdCountry.isDeleted = :isDeleted3) AND CTS_ILPMdCountry.isActive = :isActive4)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: ["CTS_ILPMdCountry.mdCountryId", "CTS_ILPMdCountry.isDeleted", "CTS_ILPMdCountry.lastModifyTime", "CTS_ILPMdCountry.lastModifierName", "CTS_ILPMdCountry.countryNameCn", "CTS_ILPMdCountry.appCode", "CTS_ILPMdCountry.continentsCode", "CTS_ILPMdCountry.createOfficeName", "CTS_ILPMdCountry.createOffice", "CTS_ILPMdCountry.creatorId", "CTS_ILPMdCountry.countryCode", "CTS_ILPMdCountry.countryNameEn", "CTS_ILPMdCountry.isActive", "CTS_ILPMdCountry.lastModifyOffice", "CTS_ILPMdCountry.createTime", "CTS_ILPMdCountry.principalGroupCode", "CTS_ILPMdCountry.recordVersion", "CTS_ILPMdCountry.lastModifyOfficeName", "CTS_ILPMdCountry.creatorName", "CTS_ILPMdCountry.lastModifierId"],
        enableCascade: true
      }

      return new Promise(resolve => {
        queryCountryInfo(data).then(res => {
          console.log("queryCountryInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    handleClick() {

    },
    //触发表单校验
    ebPartyValidate() {
      let self = this
      let flag = false;
      self.$refs.ebPartySHInfoFormRef.validate(validSH => {
        self.$refs.ebPartyCNInfoFormRef.validate(validCN => {
          self.$refs.ebPartyNTInfoFormRef.validate(validNT => {
            //this.$emit('ebPartyValidate',validSH && validCN && validNT)
            flag = validSH && validCN && validNT
            // return validSH && validCN && validNT
          })
        })
      })
      if (flag) {
        return true
      }
    },
    //触发弹出框校验
    ebPartyDialogValidate() {
      let self = this
      let flag = false;
      self.$refs.ebPartySHDialogFormRef.validate(async validSH1 => {
        self.$refs.ebPartyCNDialogFormRef.validate(async validCN1 => {
          self.$refs.ebPartyNTDialogFormRef.validate(async validNT1 => {
            self.$refs.ebPartyNT2DialogFormRef.validate(async validNT2 => {
              self.$refs.ebPartyRSHDialogFormRef.validate(async validRSH => {
                self.$refs.ebPartyRCNDialogFormRef.validate(async validRCN => {
                  self.$refs.ebPartyRNTDialogFormRef.validate(async validRNT => {
                    flag = validSH1 && validCN1 && validNT1 && validNT2 && validRSH && validRCN && validRNT
                  })
                })
              })
            })
          })
        })
      })
      if (flag) {
        return true
      }
    },
    copyCnee(val) {
      let self = this
      if (val === "1") {
        self.ebParty.ebPartyNT.partyDescription = self.ebParty.ebPartyCN.partyDescription
      } else if (val === "2") {
        self.ebParty.ebPartyNT.partyDescription = 'SAME AS CONSIGNEE'
      }
      self.ebPartyInfoValue()
    },
    ebPartyDialogClick() {
      if (this.ebPartyDialogValidate()) {
        this.$emit('getEbPartyInfo', this.ebParty)
        this.ebPartyDialogVisible = !this.ebPartyDialogVisible
      }
    },
    ebPartyInfoValue() {
      this.$emit('getEbPartyInfo', this.ebParty)
    },
    // Country/Area:
    onChangeCountryEbPartySH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartySH.countryCode = selectedRows.countryCode;
    },
    onChangeCountryEbPartyCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyCN.countryCode = selectedRows.countryCode;
    },
    onChangeCountryEbPartyNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyNT.countryCode = selectedRows.countryCode;
    },
    onChangeCountryEbPartyNT2(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyNT2.countryCode = selectedRows.countryCode;
    },
    onChangeCountryEbPartyRSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRSH.countryCode = selectedRows.countryCode;
    },
    onChangeCountryEbPartyRCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRCN.countryCode = selectedRows.countryCode;
    },
    onChangeCountryEbPartyRNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRNT.countryCode = selectedRows.countryCode;
    }
  }
};
</script>

<style scoped lang="scss">
.elbtn-save {
  float: right;
  clear: both;
  color: #1890ff;
  border: 1px solid #1890ff;
  padding: 0 5px;
  font-size: 12px;
  display: block !important
}
</style>
